import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { ISensitiveCommunities } from 'src/models/sensitive-communities.model';
import services from 'src/services/sensitive-communities.service';

export const actionTypes = {
  SENSITIVE_COMMUNITIES_FETCH: 'SENSITIVE_COMMUNITIES_FETCH',
  SENSITIVE_COMMUNITIES_ADD: 'SENSITIVE_COMMUNITIES_ADD',
  SENSITIVE_COMMUNITIES_UPDATE: 'SENSITIVE_COMMUNITIES_UPDATE',
  SENSITIVE_COMMUNITIES_DELETE: 'SENSITIVE_COMMUNITIES_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.SENSITIVE_COMMUNITIES_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.SENSITIVE_COMMUNITIES_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.SENSITIVE_COMMUNITIES_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.SENSITIVE_COMMUNITIES_DELETE,
    service: services.itemDELETE,
  },
};

export type ISensitiveCommunitiesAsync = typeof asyncActions;

export interface ISensitiveCommunitiesState extends ICommonState<ISensitiveCommunitiesAsync> {
  data?: ISensitiveCommunities;
  list: ISensitiveCommunities[];
  total: number;
}

export const defaultState: ISensitiveCommunitiesState = {
  status: {},
  list: [],
  total: 0,
};

const SensitiveCommunitiesReducer = (
  state: ISensitiveCommunitiesState = defaultState,
  action: IReducerAction<ISensitiveCommunitiesAsync>
): ISensitiveCommunitiesState => {
  switch (action.type) {
    case actionTypes.SENSITIVE_COMMUNITIES_FETCH: {
      return {
        ...state,
        list: action.payload?.sensitiveCommunities.rows ?? [],
        total: action.payload?.sensitiveCommunities.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default SensitiveCommunitiesReducer;
